<template>
    <v-container grid-list-md class="telegram-create-process">
        <v-layout row wrap>
            <v-flex md10>
                <v-form ref="form_telegram">
                    
                    <!--groupTelegram-->
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Group telegram của bạn:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                solo
                                v-model="groupTelegram"
                                required
                                placeholder="Nhập link nhóm telegram của bạn"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <!--videoRef-->
                    <v-layout align-center row v-if="videoId">
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <a href="#videoRef">
                                    <span class="blue_text label-highlight">Video hướng dẫn tạo job</span>
                                </a>
                            </div>
                        </v-flex>
                    </v-layout>

                    <!--groupGetMember-->
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Group lấy member:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                solo
                                v-model="groupGetMember"
                                placeholder="Nhập link nhóm telegram cần lấy mem (có thể bỏ trống)"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>

                    <!----note group get member---->
                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <span>1. Nhập link group mà bạn muốn lấy member từ đó để thêm vào group của bạn</span><br>
                                <span>2. Có thể không cần nhập group lấy mem. Khi đó bên mình sẽ chủ động tìm các group để kéo mem cho các bạn.</span><br>
                                <span class="red_text">Chú ý: Nhớ nhập link group, link channel không kéo được</span>
                            </div>
                        </v-flex>
                    </v-layout>
                    
                    <!--quantity-->
                    <v-layout align-center row>
                        <v-flex md4>
                            <label class="text-color">Số lượng member cần kéo:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                solo
                                v-model="quantity"
                                type="number"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    
                    <!--mobile-->
                    <v-layout align-center row class="pa-0">
                        <v-flex md4>
                            <label class="text-color">Số điện thoại liên hệ:</label>
                        </v-flex>
                        <v-flex md8>
                            <v-text-field
                                solo
                                :counter="11"
                                type="number"
                                v-model="mobile"
                                placeholder="Nhập số điện thoại"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    
                    <!----note mobile---->
                    <v-layout align-center row>
                        <v-flex offset-md4>
                            <div class="v-sheet theme--light explain">
                                <span>Nhập số điện thoại để chúng tôi có thể liên hệ khi cần thiết</span>
                            </div>
                        </v-flex>
                    </v-layout>
                    
                </v-form>

                <v-layout align-center row>
                    <v-flex md12>
                        <v-card :color="COLOR.CLICK_MENU_COLOR" height="100px">
                            <v-card-title>
                                <div class="div-total">
                                    <p>
                                        Tổng: <strong>{{totalCoin | currency_init}}</strong> Coin <br>
                                        Giá <strong class="green--text">{{price | currency_init}}</strong> Coin / 1 lần
                                    </p>
                                </div>

                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>

                <v-layout align-center row>
                    <v-flex md12>
                        <v-btn width="100%" height="50px" :color="COLOR.MAIN_COLOR" class="white--text"
                               @click="saveProcess">
                            Tạo tiến trình
                        </v-btn>
                    </v-flex>
                </v-layout>
                
                <!--video youtube-->
                <v-layout align-center row v-if="videoId" id="videoRef">
                    <v-flex md12>
                        <div class="col-sm-12 mb-n3">
                            <h3 class="text-color">HƯỚNG DẪN SỬ DỤNG</h3>
                        </div>
                        <div class="col-sm-12 mb-n3">
                            <youtube :video-id="videoId" ref="youtube"
                                 @buffering="playing"
                                 @paused="paused"
                                 @ended="paused"
                                 @playing="playing"
                                 width="100%" height="650px">
                            </youtube>
                        </div>
                    </v-flex>
                </v-layout>

            </v-flex>
        </v-layout>
        <v-overlay :value="overlay">
            <v-progress-circular
                indeterminate
                color="info"
            ></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
    import {COLOR, SEEDING} from "~/config/constant";
    import {validURLFb} from "../../common/helper.string";
    import Swal from 'sweetalert2';
    import {
        FB_POST_GET_LIST_SEEDING,
        // TELEGRAM_HISTORY,
        TELEGRAM_SAVE_PROCESS
    } from "~/store/actions.type";

    import $ from 'jquery';

    export default {
        name: "TelegramCreateProcess",
        components: {
        },
        data() {
            return {
                overlay: false,
                // Color chinh
                COLOR: COLOR,
                SEEDING: SEEDING,

                groupTelegram: '',
                groupGetMember: '',
                quantity: 1000,
                price: 0,
                totalCoin: 0,
                mobile: '',

                videoId: '',
                videoStatus: true,
                
                listSeedingApi: [],
                typeSeeding: 40,
            }
        },
        watch: {
            quantity() {
                this.calculate();
            },
            price() {
                this.calculate();
            }
        },
        mounted() {
            this.customDataFromApi();
            if ($('.menu-telegram-buff').parent().attr('aria-expanded') == "false") {
                $('.menu-telegram-buff').click();
            }
        },
        methods: {
            async customDataFromApi() {
                this.listSeedingApi = await this.$store.dispatch(FB_POST_GET_LIST_SEEDING);

                //video
                for (let i = 0; i < this.listSeedingApi.length; i++) {
                    if (this.listSeedingApi[i].type === 'telegram') {
                        if (this.listSeedingApi[i].video) {
                            let videoId = this.youtube_parser(this.listSeedingApi[i].video);
                            if (videoId) {
                                this.videoId = videoId;
                            }
                        }
                    }
                }

                this.initDefault();
            },
            initDefault() {

                for (let i = 0; i < this.listSeedingApi.length; i++) {
                    if (this.listSeedingApi[i].type === 'telegram') {
                        this.price = this.price ? this.price : this.listSeedingApi[i].fix_coin
                    }
                }
                
                this.calculate();
            },
            validateForm() {
                let valid = true;
                
                if (this.groupTelegram.trim() === '') {
                    return {check: false, message: "Vui lòng nhập Link Group telegram hợp lệ"};
                }

                if (this.quantity < 1000) {
                    return {check: false, message: "Số lượng member cần kéo tối thiểu nhập là 1000"};
                }
                
                if (this.mobile.trim() !== '') {
                    if (this.mobile.trim().length < 10
                    || this.mobile.trim().length > 11) {
                        return {check: false, message: "Số điện thoại trong khoản 10-11 ký tự"};
                    }
                }
                
                if (!validURLFb(this.groupTelegram, 't.me') 
                && !validURLFb(this.groupTelegram, 'telegram.me')) {
                    return {check: false, message: "Link Telegram không hợp lệ"};
                }
                
                return {check: valid, message: ""};
            },
            getParams() {
                let params = {
                    group_telegram: this.groupTelegram,
                    group_get_member: this.groupGetMember,
                    quantity: this.quantity,
                    price: this.totalCoin,
                    mobile: this.mobile
                };
                return params;
            },
            async saveProcess() {
                this.calculate();
                let validateForm = this.validateForm();
                if (validateForm.check) {
                    try {
                        Swal.fire({
                            title: 'Xác nhận',
                            text: "Bạn có chắc chắn muốn tạo tiến trình ",
                            icon: 'warning',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Đồng ý!',
                            cancelButtonText: 'Không'
                        }).then((result) => {
                            if (result.value) {
                                this.overlay = true;
                                this.saveProcessApi();
                            }
                        })
                    } catch (error) {
                        console.log(error);
                    }
                } else {
                    Swal.fire(
                        validateForm.message,
                        '...',
                        'error'
                    )
                }
            },
            async saveProcessApi() {
                let check = await this.$store.dispatch(TELEGRAM_SAVE_PROCESS, this.getParams());
                if (check) {
                    this.overlay = false;
                    this.$router.go();
                } else {
                    this.overlay = false;
                }


            },
            async calculate() {
                this.totalCoin = this.price * this.quantity;
            },

            playing() {
                this.videoStatus = false;
            },
            paused() {
                this.videoStatus = true;
            },
            youtube_parser(url) {
                let regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
                let match = url.match(regExp);
                return (match && match[7].length == 11) ? match[7] : false;
            }
        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";

    .telegram-create-process {
        background-color: $bgMainColor;
        max-width: 100% !important;

        .v-text-field__details {
            display: none;
        }

        .text-color {
            color: $mainColor;
            font-weight: bold;
        }

        .div-total {
            width: 100%;
            color: white;
            text-align: center;
        }

        .div-cx {
            height: 60px;

            .cx-img {
                cursor: pointer;

                &hover {
                    opacity: 0.8;
                }
            }

            .cxSelected {
                height: 60px;
                width: 60px;
            }
        }
    }
</style>
